interface Props {
  direction: "left" | "right";
  onClick: () => void;
  variant?: "light" | "dark";
}

export function CarouselArrow({ direction, onClick, variant = "light" }: Props) {
  const isLeft = direction === "left";
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={`hidden md:flex absolute top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full transition-all hover:scale-105 active:scale-95 ${
        variant === "dark"
          ? "bg-white/15 hover:bg-white/25 text-white"
          : "bg-black/5 hover:bg-black/10 text-ink-1"
      }`}
      style={{ [isLeft ? "left" : "right"]: 12 }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {isLeft ? (
          <polyline points="15 18 9 12 15 6" />
        ) : (
          <polyline points="9 6 15 12 9 18" />
        )}
      </svg>
    </button>
  );
}
